import { ANNOTATION_VALUE } from "@/constants/annotation-values"

import type { TargetCondition } from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

export function calculateBinaryHeaderPercent(
  mos: RunMetricOutput[],
  includeUnknowns: boolean,
  targetCondition?: TargetCondition,
): string | null {
  const valueCounts = mos.reduce((acc: Record<string, number>, curr) => {
    if (curr.string_value) {
      const normalizedValue = curr.string_value.trim()
      acc[normalizedValue] = (acc[normalizedValue] || 0) + 1
    }
    return acc
  }, {})

  const percentageTotal = includeUnknowns
    ? (valueCounts[ANNOTATION_VALUE.YES] || 0) +
      (valueCounts[ANNOTATION_VALUE.NO] || 0) +
      (valueCounts[ANNOTATION_VALUE.UNKNOWN] || 0)
    : (valueCounts[ANNOTATION_VALUE.YES] || 0) +
      (valueCounts[ANNOTATION_VALUE.NO] || 0)

  if (percentageTotal === 0) {
    return null
  }

  let successValue: string = ANNOTATION_VALUE.YES
  if (
    targetCondition &&
    "target_values" in targetCondition &&
    targetCondition.target_values?.length > 0
  ) {
    successValue = targetCondition.target_values[0]
  }
  const successCount = valueCounts[successValue] || 0
  return `${((successCount / percentageTotal) * 100).toFixed(0)}%`
}

export function hasBinaryUnknowns(mos: RunMetricOutput[]): boolean {
  return mos.some((m) => m.string_value?.trim() === ANNOTATION_VALUE.UNKNOWN)
}
